var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgResearchAndPublicPolicy = function SvgResearchAndPublicPolicy(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#research_and_public_policy_svg__clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.995 119.989c33.134 0 59.994-26.86 59.994-59.995C119.989 26.861 93.129 0 59.994 0 26.861 0 0 26.86 0 59.995c0 33.134 26.86 59.994 59.995 59.994z",
    fill: "#D7DBDB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.29 19.656V62.79",
    stroke: "#FFFF89",
    strokeWidth: 6.548,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.29 25.342a8.731 8.731 0 018.73 8.732v23.04H35.558v-23.04a8.731 8.731 0 018.731-8.732z",
    fill: "#ABB3B3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.29 19.656V62.79M77.97 40.786a22.92 22.92 0 00-16.218-6.712",
    stroke: "#8B9494",
    strokeWidth: 6.548,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.97 40.786a22.92 22.92 0 01-16.218 39.127",
    stroke: "#BAC2C2",
    strokeWidth: 6.548,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.976 96.426a19.786 19.786 0 1139.563 0",
    fill: "#ABB2B2"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "a",
    maskUnits: "userSpaceOnUse",
    x: 41,
    y: 76,
    width: 41,
    height: 21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M41.98 96.421a19.788 19.788 0 1139.564 0",
    fill: "#ABB3B3"
  })), /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M61.752 34.074a22.92 22.92 0 11-22.92 22.92",
    stroke: "#8B9494",
    strokeWidth: 6.548,
    strokeMiterlimit: 10
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.752 42.805a8.731 8.731 0 100-17.463 8.731 8.731 0 000 17.463z",
    fill: "#8B9494"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.164 71.738h24.262",
    stroke: "#BAC2C2",
    strokeWidth: 6.548,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "research_and_public_policy_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h120v120H0V0z",
    fill: "#fff"
  })))));
};
export { SvgResearchAndPublicPolicy as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTIwIiBoZWlnaHQ9IjEyMCIgdmlld0JveD0iMCAwIDEyMCAxMjAiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+PGcgY2xpcC1wYXRoPSJ1cmwoI3Jlc2VhcmNoX2FuZF9wdWJsaWNfcG9saWN5X3N2Z19fY2xpcDApIj48cGF0aCBkPSJNNTkuOTk1IDExOS45ODljMzMuMTM0IDAgNTkuOTk0LTI2Ljg2IDU5Ljk5NC01OS45OTVDMTE5Ljk4OSAyNi44NjEgOTMuMTI5IDAgNTkuOTk0IDAgMjYuODYxIDAgMCAyNi44NiAwIDU5Ljk5NWMwIDMzLjEzNCAyNi44NiA1OS45OTQgNTkuOTk1IDU5Ljk5NHoiIGZpbGw9IiNEN0RCREIiLz48cGF0aCBkPSJNNDQuMjkgMTkuNjU2VjYyLjc5IiBzdHJva2U9IiNGRkZGODkiIHN0cm9rZS13aWR0aD0iNi41NDgiIHN0cm9rZS1taXRlcmxpbWl0PSIxMCIvPjxwYXRoIGQ9Ik00NC4yOSAyNS4zNDJhOC43MzEgOC43MzEgMCAwMTguNzMgOC43MzJ2MjMuMDRIMzUuNTU4di0yMy4wNGE4LjczMSA4LjczMSAwIDAxOC43MzEtOC43MzJ6IiBmaWxsPSIjQUJCM0IzIi8+PHBhdGggZD0iTTQ0LjI5IDE5LjY1NlY2Mi43OU03Ny45NyA0MC43ODZhMjIuOTIgMjIuOTIgMCAwMC0xNi4yMTgtNi43MTIiIHN0cm9rZT0iIzhCOTQ5NCIgc3Ryb2tlLXdpZHRoPSI2LjU0OCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PHBhdGggZD0iTTc3Ljk3IDQwLjc4NmEyMi45MiAyMi45MiAwIDAxLTE2LjIxOCAzOS4xMjciIHN0cm9rZT0iI0JBQzJDMiIgc3Ryb2tlLXdpZHRoPSI2LjU0OCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIi8+PHBhdGggZD0iTTQxLjk3NiA5Ni40MjZhMTkuNzg2IDE5Ljc4NiAwIDExMzkuNTYzIDAiIGZpbGw9IiNBQkIyQjIiLz48bWFzayBpZD0iYSIgbWFza1VuaXRzPSJ1c2VyU3BhY2VPblVzZSIgeD0iNDEiIHk9Ijc2IiB3aWR0aD0iNDEiIGhlaWdodD0iMjEiPjxwYXRoIGQ9Ik00MS45OCA5Ni40MjFhMTkuNzg4IDE5Ljc4OCAwIDExMzkuNTY0IDAiIGZpbGw9IiNBQkIzQjMiLz48L21hc2s+PGcgbWFzaz0idXJsKCNhKSI+PHBhdGggZD0iTTYxLjc1MiAzNC4wNzRhMjIuOTIgMjIuOTIgMCAxMS0yMi45MiAyMi45MiIgc3Ryb2tlPSIjOEI5NDk0IiBzdHJva2Utd2lkdGg9IjYuNTQ4IiBzdHJva2UtbWl0ZXJsaW1pdD0iMTAiLz48L2c+PHBhdGggZD0iTTYxLjc1MiA0Mi44MDVhOC43MzEgOC43MzEgMCAxMDAtMTcuNDYzIDguNzMxIDguNzMxIDAgMDAwIDE3LjQ2M3oiIGZpbGw9IiM4Qjk0OTQiLz48cGF0aCBkPSJNMzIuMTY0IDcxLjczOGgyNC4yNjIiIHN0cm9rZT0iI0JBQzJDMiIgc3Ryb2tlLXdpZHRoPSI2LjU0OCIgc3Ryb2tlLW1pdGVybGltaXQ9IjEwIiBzdHJva2UtbGluZWNhcD0icm91bmQiLz48L2c+PGRlZnM+PGNsaXBQYXRoIGlkPSJyZXNlYXJjaF9hbmRfcHVibGljX3BvbGljeV9zdmdfX2NsaXAwIj48cGF0aCBkPSJNMCAwaDEyMHYxMjBIMFYweiIgZmlsbD0iI2ZmZiIvPjwvY2xpcFBhdGg+PC9kZWZzPjwvc3ZnPg==";